const r=r=>Array.isArray(r);export{r as isKeyframesTarget};
